import { lighten } from '@mui/material';
import React from 'react';
import Avatar, { avatarProps } from 'ui-component/extended/Avatar';

function stringToColor(string: string) {
  let hash = 0;
  let i;

  for (i = 0; i < string.length; i += 1) {
    hash = string.charCodeAt(i) + ((hash << 5) - hash);
  }

  let color = '#';

  for (i = 0; i < 3; i += 1) {
    const value = (hash >> (i * 8)) & 0xff;
    color += `00${value.toString(16)}`.slice(-2);
  }

  return color;
}

function stringAvatar(name: string) {
  return {
    sx: {
      bgcolor: lighten(stringToColor(name), 0.75),
      color: stringToColor(name),
    },
    children:
      name.split(/\s+/)?.length > 1
        ? `${name.split(/\s+/)[0][0] ?? ''}${name.split(/\s+/)[1][0] ?? ''}`
        : name[0],
  };
}

interface ColoredLetterAvatarProps extends avatarProps {
  name: string;
}

const ColoredLetterAvatar: React.FC<ColoredLetterAvatarProps> = ({
  className,
  color,
  outline,
  size,
  sx,
  name,
  ...others
}) => {
  const { sx: thisSx, children } = stringAvatar(name);

  return (
    <Avatar
      className={className}
      color={color}
      outline={outline}
      size={size}
      sx={{ ...sx, ...thisSx }}
      children={children}
      {...others}
    />
  );
};

export default ColoredLetterAvatar;
